import React, { useState, useEffect, useRef } from 'react';
import TR from './../../Trans';
import Button from '@mui/material/Button';
import FormGroup from '@mui/material/FormGroup';
import BDialog from './BDialog';
import DialogActions from '@mui/material/DialogActions';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Capacitor } from '@capacitor/core';
import AddBackgroundMusicPlayList from './../dialogs/AddBackgroundMusicPlaylist';
import TextField from '@mui/material/TextField';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Keyboard } from '@capacitor/keyboard';
import Grid from '@mui/material/Grid';
import AlbumIcon from '@mui/icons-material/Album';
import AddSinger from './../dialogs/AddSinger';
import IconButton from '@mui/material/IconButton';
import DialogContent from '@mui/material/DialogContent';
import MuvikaService from './../../services/muvika';
import MenuItem from '@mui/material/MenuItem';
import PositionButtons from '../items/PositionButtons';
import SelectSongPosition from './SelectSongPosition';
import Select from '@mui/material/Select';
import Paper from '@mui/material/Paper';
import InfoIcon from '@mui/icons-material/Info';
import Stack from '@mui/material/Stack';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import CreatorsDialog from './CreatorsDialog';
import PitchButtons from '../items/PitchButtons';
import sessionStore from './../../stores/session';
import accountStore from '../../stores/account';
import settingsStore from '../../stores/settings';
import singersStore from './../../stores/singers';
import bgPerformanceStore from '../../stores/bgPerformance';
import messageStore from './../../stores/message';
import EditPlayList from './EditPlayList';
import BackgroundHistoryListItem from './../items/BackgroundHistoryListItem';
import bgSearchStore from '../../stores/bgSearch';
import navigationStore from '../../stores/navigation';
import Link from '@mui/material/Link';
import { Views } from './../../enums/enums';

function BackgroundMusicEditPlayListPerformance(props) {

  const sessionToken = sessionStore((state) => state.sessionToken);
  const settings = settingsStore((state) => state.settings);
  const setError = messageStore((state) => state.setError);
  const timeDiff = accountStore((state) => state.timeDiff);

  const itemsOnPage = 25;
  const setSearchQuery = bgSearchStore((state) => state.setSearchQuery);
  const goToView = navigationStore((state) => state.goToView);
  const search = bgSearchStore((state) => state.search);
  const setOnlyArtist = bgSearchStore((state) => state.setOnlyArtist);

  const [currentPlayList, setCurrentPlayList] = useState(null);
  const [isAddPlayListOpen, setIsAddPlayListOpen] = useState(false);
  const [creators, setCreators] = useState(null);
  const [isSelectSongPositionOpen, setIsSelectSongPositionOpen] = useState(false);
  const [currentPos, setCurrentPos] = useState(null);

  const dialogRef = useRef(null);

  const handleOpenSelectSongPosition = () => {
    setIsSelectSongPositionOpen(true);
  };

  const handleCloseSelectSongPosition = () => {
    setIsSelectSongPositionOpen(false);
  };

  const handleOpenAddPlayList = () => {
    setIsAddPlayListOpen(true);
  };

  const handleCloseAddPlayList = () => {
    setIsAddPlayListOpen(false);
  };

  const handlePlayListCreation = (playListName) => {
    if (playListName.length > 0) {
      MuvikaService.createMusicPlayList(sessionToken, playListName)
        .then(function (res) {
          if (res.data.error) {
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            bgPerformanceStore.getState().getPlayLists(sessionToken, false);
            let newPlayList = res.data.data;
            if (!newPlayList.items) {
              newPlayList.items = [];
            }
            setCurrentPlayList(newPlayList);
            setIsAddPlayListOpen(false);
          }
        });
    } else {
      setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
    }
  };

  useEffect(() => {
    if (props.performance) {
      if (settings) {
        if (!settings.usage_mode || settings.usage_mode === "restaurant") {
          setCurrentPos(props.performance.position);
        } else if (settings.usage_mode === "booth") {
          setCurrentPos(props.playQueue.items.length);
        }
      }
    }
  }, [props.performance]);

  useEffect(() => {
    if (currentPlayList) {
      if (currentPlayList.id === props.playList.id) {
        if (props.performance) {
          setCurrentPos(props.performance.position);
        } else {
          setCurrentPos(props.playList.items.length - 1);
        }
      } else {
        setCurrentPos(currentPlayList.items.length);
      }
    } else if (props.playQueue) {
      setCurrentPos(props.playQueue.items.length);
    }
  }, [currentPlayList]);

  const handlePosChange = (event) => {
    let pos = event.target.value;
    console.log(pos);
    if (pos || pos == 0) {
      pos = parseInt(pos);
      if (pos != -1) {
        setCurrentPos(pos);
      }
    } else {
      pos = -1;
    }
    if (pos === -1) {
      handleOpenSelectSongPosition();
    }
  };

  const handleChoosePosition = (pos) => {
    if (pos || pos == 0) {
      if (currentPlayList) {
        if (pos >= currentPlayList.items.length) {
          setCurrentPos(currentPlayList.items.length - 1);
        } else {
          setCurrentPos(pos);
        }
      } else {
        if (props.playQueue) {
          if (pos >= props.playQueue.items.length) {
            setCurrentPos(props.playQueue.items.length - 1);
          } else {
            setCurrentPos(pos);
          }
        }
      }
    }
    handleCloseSelectSongPosition();
  };

  const scrollToDown = () => {
    let dialogContainers = document.getElementsByClassName("MuiDialog-container");
    if (dialogContainers.length > 0) {
      for (var i = 0; i < dialogContainers.length; i++) {
        dialogContainers[i].scrollTop = dialogContainers[i].scrollHeight;
      }
    }
  };

  useEffect(() => {
    if (props.open) {
      if (Capacitor.isNativePlatform()) {
        Keyboard.addListener('keyboardDidShow', info => {
          setTimeout(() => scrollToDown(), 100);
          Keyboard.removeAllListeners();
        });
      } else {
        setTimeout(() => scrollToDown(), 100);
      }
      if (props.isPlayingNow) {
        setCurrentPos(props.playQueue.items.length);
        setCurrentPlayList(null);
      } else {
        setCurrentPlayList(props.playList);
        if (settings) {
          if (!settings.usage_mode || settings.usage_mode === "restaurant") {
            setCurrentPlayList(props.playList);
          } else if (settings.usage_mode === "booth") {
            setCurrentPlayList(null);
          }
        }
        if (props.performance) {
          if (settings) {
            if (!settings.usage_mode || settings.usage_mode === "restaurant") {
              setCurrentPos(props.performance.position);
            } else if (settings.usage_mode === "booth") {
              setCurrentPos(props.playQueue.items.length);
            }
          }
        }
      }
    }
  }, [props.open]);

  useEffect(() => {
    getCreators();
  }, []);

  const getCreators = () => {
    if (props.track) {
      if (props.track.track_id) {
        MuvikaService.getTrackCreators(sessionToken, props.track.track_id)
          .then(function (res) {
            if (res.data.data) {
              if (res.data.error) {
                setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              } else {
                setCreators(res.data.data.items);
              }
            }
          })
          .catch(function () { });
      }
    }
  };

  const [isCreatorsDialogOpen, setIsCreatorsDialogOpen] = useState(false);

  const handleOpenCreatorsDialog = () => {
    getCreators();
    setIsCreatorsDialogOpen(true);
  };

  const handleCloseCreatorsDialog = () => {
    setIsCreatorsDialogOpen(false);
  };

  const playListList = () => {
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        if (props.playLists) {
          return props.playLists.map((playList) =>
            <MenuItem key={playList.id} value={playList.id}>{playList.name}</MenuItem>
          );
        }
      }
    }
  };

  const handlePlayListChange = (event) => {
    let playListId = event.target.value;
    if (playListId != -1) {
      let playList = props.playLists.find(x => x.id == playListId);
      if (playList) {
        setCurrentPlayList(playList);
      }
    } else {
      setCurrentPlayList(null);
    }
  };

  const playListContainer = () => {
    if (props.playLists) {
      return <FormGroup>
        <InputLabel id="new-playlist-label">{TR.cm_playlist}</InputLabel>
        <Grid container spacing={0}>
          <Grid item xs={10.5}>
            <Select
              className="muvika-dialog-select"
              labelId="new-playlist-label"
              label="Playlist"
              value={currentPlayList ? currentPlayList.id : -1}
              onChange={handlePlayListChange}
            >
              <MenuItem value={-1}>{TR.cm_current_music_playqueue}</MenuItem>
              {playListList()}
            </Select>
          </Grid>
          <Grid item xs={1.5}>
            {renderAddPlayListButton()}
          </Grid>
        </Grid>
      </FormGroup>;
    }
  };

  const checkIfBeforeNow = (dateStr) => {
    var now = new Date();
    var date = new Date(dateStr);
    now.setMinutes(now.getMinutes() + Math.round(timeDiff));
    return date < now;
  };


  const playNextButton = () => {
    if (accountStore.getState().account && settings) {
      if (accountStore.getState().account.subscription.valid != 0 && !settings.hide_play_now) {
        return <Button color="success" onClick={() => handleEditPerformance(true)}><span className="muvika-playnow-icon"><PlayArrowIcon /></span> {TR.cm_play_now}</Button>;
      }
    }
  };

  const handleEditPerformance = (playNow = false) => {
    props.onEditPerformance(props.performanceId, playNow ? null : currentPlayList, playNow ? 0 : currentPos, playNow);
  };

  const renderAddPlayListButton = () => {
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        return <IconButton className="muvika-dialog-plus-button" color="white" component="label" onClick={handleOpenAddPlayList}>
          <AddCircleIcon />
        </IconButton>;
      }
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      if (isCreatorsDialogOpen) {
        handleCloseCreatorsDialog();
      } else if (isAddPlayListOpen) {
        handlePlayListCreation();
      } else {
        handleEditPerformance();
      }
    }
  };

  const renderEditPerformanceButton = () => {
    if (currentPlayList) {
      //console.log(currentPlayList);
      if (currentPlayList.id === props.playList.id) {
        return <Button
          color="success"
          className="muvika-dialog-action-right"
          onClick={() => {
            handleEditPerformance();
          }}
        >{TR.cm_save}
        </Button>;
      } else {
        return <Button
          color="success"
          className="muvika-dialog-action-right"
          onClick={() => {
            handleEditPerformance();
          }}
        >
          {TR.cm_add_to_list}
        </Button>;
      }
    } else {
      return <Button
        color="success"
        className="muvika-dialog-action-right"
        onClick={() => {
          handleEditPerformance();
        }}
      >
        {TR.cm_add_to_queue}
      </Button>;
    }
  };

  const renderPositionButtons = () => {
    if (settings) {
      let curPos = currentPos;
      if (currentPos || curPos == 0) {
        if (curPos > 2) {
          curPos = -1;
        }
      }
      if (currentPlayList) {
        if (currentPlayList.id === props.playList.id) {
          if (currentPos === currentPlayList.items.length - 1) {
            curPos = currentPlayList.items.length - 1;
          }
        } else if (currentPos === currentPlayList.items.length) {
          curPos = currentPlayList.items.length;
        }
        return <Paper className="muvika-pos-buttons">
          <p className="muvika-pos-title">
            {TR.cm_performance_pos}
          </p>
          <PositionButtons
            value={curPos}
            performances={currentPlayList.items}
            onPosChange={handlePosChange}
            currentPosition={currentPos}
            isPlayQueue={false}
            isAdding={currentPlayList.id !== props.playList.id}
            isPlayList={true}
          />
        </Paper>;
      } else if (props.playQueue) {
        if (currentPos === props.playQueue.items.length) {
          curPos = props.playQueue.items.length;
        }
        return <Paper className="muvika-pos-buttons">
          <p className="muvika-pos-title">
            {TR.cm_performance_pos}
          </p>
          <PositionButtons
            value={curPos}
            performances={props.playQueue.items}
            onPosChange={handlePosChange}
            currentPosition={currentPos}
            isPlayQueue={true}
            isAdding={true}
          />
        </Paper>;
      }
    }
  };

  const renderSelectSongPosition = () => {
    if (currentPlayList) {
      if (currentPlayList.id === props.playList.id) {
        return <SelectSongPosition
          open={isSelectSongPositionOpen}
          onClose={handleCloseSelectSongPosition}
          performances={currentPlayList.items}
          track={props.track}
          performance={props.performance}
          onChoosePosition={(pos) => {
            handleChoosePosition(pos);
          }}
        />;
      } else {
        return <SelectSongPosition
          open={isSelectSongPositionOpen}
          onClose={handleCloseSelectSongPosition}
          performances={currentPlayList.items}
          track={props.track}
          onChoosePosition={(pos) => {
            handleChoosePosition(pos);
          }}
        />;
      }
    } else if (props.playQueue) {
      return <SelectSongPosition
        open={isSelectSongPositionOpen}
        track={props.track}
        onClose={handleCloseSelectSongPosition}
        performances={props.playQueue.items}
        onChoosePosition={(pos) => {
          handleChoosePosition(pos);
        }}
      />;
    }
  };

  const handleSearchArtist = () => {
    props.onClose();
    setOnlyArtist();
    setSearchQuery(props.track.artist);
    search(sessionToken, itemsOnPage);
    goToView(Views.BackgroundMusicSearch);
  };

  return (
    <BDialog openToLeft={true} disableRestoreFocus ref={dialogRef} open={props.open} onKeyDown={handleKeyDown} onClose={() => {
      props.onClose();
    }}>
      {renderSelectSongPosition()}
      <AddBackgroundMusicPlayList
        open={isAddPlayListOpen}
        onClose={handleCloseAddPlayList}
        onPlayListCreation={handlePlayListCreation}
      />
      <CreatorsDialog open={isCreatorsDialogOpen} onClose={handleCloseCreatorsDialog} creators={creators} track={props.track} />
      <DialogContent>
        <div className="muvika-cover-music-image">
          <AlbumIcon />
        </div>
        <h4 className="muvika-track-title">
          <Link className="muvika-link-nodec" onClick={handleSearchArtist}>
            {props.track.artist}
          </Link> - {props.track.title} ({props.track.kcode})
          <IconButton color="white" component="label" onClick={handleOpenCreatorsDialog}>
            <InfoIcon />
          </IconButton>
        </h4>

        <Stack spacing={5}>
          {playListContainer()}
          {renderPositionButtons()}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={4} justifyContent="center">
          <Button color="secondary" onClick={props.onClose}>{TR.cm_cancel}</Button>
          {renderEditPerformanceButton()}
          {playNextButton()}
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default BackgroundMusicEditPlayListPerformance;